import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import Login from "@/views/Login.vue";

import EventList from "@/views/event/EventList.vue";
import EventDetails from "@/views/event/EventDetails.vue";
import EventAnalysis from "@/views/event/EventAnalysis.vue";
import BusinessAnalysis from "@/views/event/BusinessAnalysis.vue";

import RequestDocumentList from "@/views/request-document/RequestDocumentList.vue";
import RequestDocumentDetails from "@/views/request-document/RequestDocumentDetails.vue";

import ObjectionEventList from "@/views/objection-event/ObjectionEventList.vue";
import ObjectionEventDetails from "@/views/objection-event/ObjectionEventDetails.vue";
import ObjectionEventAnalysis from "@/views/objection-event/ObjectionEventAnalysis.vue";
import ObjectionBusinessAnalysis from "@/views/objection-event/ObjectionBusinessAnalysis.vue";
import ObjectionEventProposal from "@/views/objection-event/ObjectionEventProposal.vue";
import ObjectionEventAddSingle from "@/views/objection-event/ObjectionEventAddSingle.vue";
import ObjectionEventAddMultiple from "@/views/objection-event/ObjectionEventAddMultiple.vue";

import PlanAdherenceList from "@/views/plan-adherence/PlanAdherenceList.vue";
import PlanAdherenceDetails from "@/views/plan-adherence/PlanAdherenceDetails.vue";
import PlanAdherenceCharts from "@/views/plan-adherence/PlanAdherenceCharts.vue";

import OfficioAnalysisList from "@/views/officio-analysis/OfficioAnalysisList.vue";
import OfficioAnalysisDetails from "@/views/officio-analysis/OfficioAnalysisDetails.vue";

import QgcList from "@/views/qgc/QgcList.vue";
import QgcDetails from "@/views/qgc/QgcDetails.vue";
import PaymentProofList from "@/views/payment-proof/PaymentProofList.vue";
import PaymentProofImport from "@/views/payment-proof/PaymentProofImport.vue";
import CreditCertificateList from "@/views/credit-certificate/CreditCertificateList.vue";
import CreditCertificateForm from "@/views/credit-certificate/CreditCertificateForm.vue";
import CreditCertificateImport from "@/views/credit-certificate/CreditCertificateImport.vue";

import * as jwt from "jwt-decode";

//the route guard
const guard = function (to: any, from: any, next: any) {
  const token = localStorage.getItem("token");

  // const checked = this.$check(to.name, 'GET');


  const publicPath = to.matched.find(
    (path) => path.name === "Public" || path.name === "Home"
  );
  if (!token && to.path !== "/login" && !publicPath) {
    next({
      path: "/login",
    });
  } else {

    if (to.name == "Home") {
      next();
      return;
    }

    const resolvedToken = jwt(token);

    // const profile = adminProfiles.find((x) => x.id === resolvedToken.data.profile);

    // if(profile.permissions && profile.permissions[0] === '*') return next();

    // const checkPermission = profile.permissions.find((x) => x.path === to.name);

    // if(!checkPermission) {
    //   next({
    //     path: "/home",
    //   });
    //   return;
    // }

    // const checkMethod = checkPermission.method.includes('GET')

    // if(!checkMethod) {
    //   next({
    //     path: "/home",
    //   });
    //   return;
    // }

    next();
  }
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/layouts/Public.vue"),
    children: [
      {
        path: "/login",
        name: "login",
        component: Login,
      },
      {
        path: "/",
        redirect: "/login",
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/layouts/Private.vue"),
    beforeEnter: guard,
    children: [
      {
        path: "/home",
        name: "Home",
        component: Home,
        beforeEnter: guard,
      },
      {
        path: "/adesao-plano",
        name: "PlanAdherence",
        component: PlanAdherenceList,
        beforeEnter: guard,
      },
      {
        path: "/adesao-plano/graficos",
        name: "PlanAdherenceCharts",
        component: PlanAdherenceCharts,
        beforeEnter: guard,
      },
      {
        path: "/adesao-plano/:id",
        name: "PlanAdherence",
        component: PlanAdherenceDetails,
        beforeEnter: guard,
      },
      {
        path: "/analise-oficio",
        name: "OfficioAnalysis",
        component: OfficioAnalysisList,
        beforeEnter: guard, 
      },
      {
        path: "/analise-oficio/:id",
        name: "OfficioAnalysis",
        component: OfficioAnalysisDetails,
        beforeEnter: guard,
      },
      {
        path: "/divergencias",
        name: "Event",
        component: EventList,
        beforeEnter: guard,
      },
      {
        path: "/divergencias/:id",
        name: "Event",
        component: EventDetails,
        beforeEnter: guard,
      },
      {
        path: "/revisao-credito",
        name: "ObjectionEvent",
        component: ObjectionEventList,
        beforeEnter: guard,
      },
      {
        path: "/revisao-credito/:id",
        name: "ObjectionEvent",
        component: ObjectionEventDetails,
        beforeEnter: guard,
      },
      {
        path: "/revisao-credito-analise-pedido",
        name: "ObjectionEventAnalysis",
        component: ObjectionEventAnalysis,
        beforeEnter: guard,
      },
      {
        path: "/revisao-credito-analise-negocios",
        name: "ObjectionBusinessAnalysis",
        component: ObjectionBusinessAnalysis,
        beforeEnter: guard,
      },
      {
        path: "/revisao-credito-adicionar-pedido",
        name: "ObjectionEventAddSingle",
        component: ObjectionEventAddSingle,
        beforeEnter: guard,
      },
      {
        path: "/revisao-credito-adicionar-multiplos",
        name: "ObjectionEventAddMultiple",
        component: ObjectionEventAddMultiple,
        beforeEnter: guard,
      },
      {
        path: "/divergencias-analise",
        name: "Event",
        component: EventAnalysis,
        beforeEnter: guard,
      },
      {
        path: "/divergencias-business-analise",
        name: "Event",
        component: BusinessAnalysis,
        beforeEnter: guard,
      },
      {
        path: "/revisao-credito-contraproposta",
        name: "ObjectionEventProposal",
        component: ObjectionEventProposal,
        beforeEnter: guard,
      },
      {
        path: "/qgc",
        name: "Qgc",
        component: QgcList,
        beforeEnter: guard,
      },
      {
        path: "/qgc/:id",
        name: "Qgc",
        component: QgcDetails,
        beforeEnter: guard,
      },
      {
        path: "/comprovantes-pagamento",
        name: "PaymentProof",
        component: PaymentProofList,
        beforeEnter: guard,
      },
      {
        path: "/comprovantes-pagamento/importar",
        name: "PaymentProofImport",
        component: PaymentProofImport,
        beforeEnter: guard,
      },
      {
        path: "/certidoes-habilitacao",
        name: "CreditCertificate",
        component: CreditCertificateList,
        beforeEnter: guard,
      },
      {
        path: "/certidoes-habilitacao/nova",
        name: "CreditCertificateForm",
        component: CreditCertificateForm,
        beforeEnter: guard,
      },
      {
        path: "/certidoes-habilitacao/importar",
        name: "CreditCertificateImport",
        component: CreditCertificateImport,
        beforeEnter: guard,
      },
      {
        path: "/solicitacao-documentos",
        name: "RequestDocument",
        component: RequestDocumentList,
        beforeEnter: guard,
      },
      {
        path: "/solicitacao-documentos/:id",
        name: "RequestDocument",
        component: RequestDocumentDetails,
        beforeEnter: guard,
      },
    ],
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
